import React, { useRef, useState } from 'react';
import { action } from '../lib/actionHelpers.js';
import getMessageIcon from '../lib/getMessageIcon.js';
import { getLeadSearch } from '../redux/actions/appActions.js';
import { useSelector } from 'react-redux';
import selectors from '../selectors/selectors.js';
import SVG from '../images/svg/SVG.js';

const debounceLength = 300;

const LeadSearchBar = (props) => {
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const leadSearchResults = useSelector((state) => state.app.leadSearch);

  const [search, setSearch] = useState('');
  const [optionsIndex, setOptionsIndex] = useState(0);
  const [searchFocused, setSearchFocused] = useState(false);
  const [searching, setSearching] = useState(false);

  const searchInput = useRef(null);
  const lastId = useRef(undefined);

  let options = leadSearchResults.length === 0 && search ? [{ first_name: 'No', last_name: 'Results', value: null }] : searching && search ? [{ first_name: 'Searching', last_name: '', value: null }] : [...leadSearchResults];

  const resetSearch = () => {
    setSearch('');
    searchInput.current.blur();
    setSearchFocused(false);
    action('DELETE_LEAD_SEARCH');
  };

  const focusSearchInput = () => {
    setTimeout(() => {
      if (searchInput.current) {
        searchInput.current.focus();
      }
    }, 100);
  };

  const handleOptionClick = (opt) => {
    let option = opt === null && options.length === 1 && !search ? options[0] : opt;
    if (!(option || {}).id) {
      return;
    }
    if (opt === null && options.length !== 1 && !search) {
      focusSearchInput();
    }
    setSearch('');
    if (!(option || {}).id) {
      return focusSearchInput();
    }
    if (typeof props.onSelection === 'function') {
      props.onSelection(opt);
      resetSearch();
    }
  };

  const handleSearchIconClick = () => {
    setSearchFocused(true);
    setTimeout(() => {
      if (searchInput.current) {
        searchInput.current.focus();
      }
    }, 100);
  };

  const handleSearchCloseClick = () => {
    resetSearch();
  };

  const handleSearchFocus = () => {
    setSearchFocused(true);
  };

  const handleSearchBlur = () => {
    if (!search) {
      setSearchFocused(false);
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Escape') {
      resetSearch();
    }
  };

  const handleSearchKeyUp = (e) => {
    if (e.key === 'Enter') {
      setSearch('');
      handleOptionClick(options[optionsIndex]);
      return;
    }
    if (e.key === 'Escape') {
      setSearch('');
      return;
    }
    let newIndex = (
      {
        ArrowUp: (n) => n - 1,
        ArrowDown: (n) => n + 1,
        PageUp: (n) => n - 7,
        PageDown: (n) => n + 7,
        Home: () => 0,
        End: () => options.length - 1,
      }[e.key] || ((n) => n)
    )(optionsIndex);
    newIndex = newIndex < 0 ? 0 : newIndex;
    newIndex = newIndex > options.length - 1 ? options.length - 1 : newIndex;
    if (newIndex !== optionsIndex) {
      setOptionsIndex(newIndex);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setOptionsIndex(0);
    const id = Math.random();
    if (value.length > 2) {
      lastId.current = id;
      setTimeout(() => {
        if (lastId.current === id) {
          setSearching(true);
          getLeadSearch({ serviceProviderId, value: String(value).trim() }, (data) => {
            setSearching(false);
          });
        }
      }, debounceLength);
    }
  };

  return (
    <form
      autoComplete={'off'}
      onSubmit={(e) => {
        e.preventDefault();
        return false;
      }}
    >
      <div className={`lead-search ${searchFocused ? 'active ' : ''}`}>
        <SVG icon={'PersonSearch'} basic={true} className="search-icon" onClick={handleSearchIconClick} />
        <input type="text" className="search-input" placeholder={props.placeholder || 'Search Customers'} ref={searchInput} value={search || ''} onChange={(e) => handleSearchChange(e)} onFocus={handleSearchFocus} onBlur={handleSearchBlur} onKeyDown={handleSearchKeyDown} onKeyUp={handleSearchKeyUp} />
        <img className={`lead-search-close-button`} src={getMessageIcon('icon-close')} alt={''} onClick={handleSearchCloseClick} />
        {options.length > 0 && (
          <div className={`lead-search-options ${searchFocused ? 'active' : ''}`}>
            <div className={`lead-search-options-inner-wrapper`}>
              {options.map((option, j) => (
                <div className={`lead-search-option ${j === optionsIndex ? 'active' : ''} ${option.value === null ? 'placeholder' : ''}`} key={j} onClick={(e) => handleOptionClick(option)}>
                  <div className={'heading'}>{option.first_name + ' ' + option.last_name}</div>
                  <div className={'subheading'}>{option.business_name}</div>
                  {(option.contacts || []).length > 0 && (
                    <div className={'contacts'}>
                      {(option.contacts || []).map((n, idx) => (
                        <div className={'contact'} key={idx} data-title={n}>
                          {String(n)
                            .split(' ')
                            .map((n) => String(n).slice(0, 1).toUpperCase())
                            .join('')}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default LeadSearchBar;
